import { Alert, Grid } from '@mui/material'
import AdminField from '../../../layout/AdminField'

function FormCustomization(props: any) {

    const { tabValue, tabOrder, campaign, handleFormStateChange } = props

  return  <div
  role="tabpanel"
  hidden={tabValue !== tabOrder}
  id={`simple-tabpanel-${tabOrder}`}
  aria-labelledby={`simple-tab-${tabOrder}`}
>
  <Grid container spacing={4} sx={{ mb: 4 }}>
    <AdminField
      label="Bilgileri Doğrula"
      type="switch"
      value={campaign.formState.duplicateCheck}
      onChange={(value) =>
        handleFormStateChange("duplicateCheck", value)
      }
      helperText="Form dolduran kullanıcıların aynı isim, telefon veya email ile üye olmaması için bu alanı işaretleyiniz"
    />
    <Alert sx={{ my: 3, mx: 12 }} severity="info">
      Aşağıdaki alanlardan kullanıcı bilgileri formunu özelleştirebilirsiniz.
      Hangi alanların dahil, hangilerinin kapalı olacağını açıp kapatabilir,
      yasal sözleşme onay kutucuğu yazısını <strong>&#40;metnin kendisini değil,
      onu bu kutucuğa a etiketi olarak ekleyeceksiniz. Örnek metinden
      faydalanabilirsiniz&#41;</strong>,<strong>Onay İzin Kutucuğu Yazısı</strong>nı
      ekleyebilirsiniz. SÖzleşme ve onay alanları boş kaldığında
      görünmeyecektir.<br /><br />
      Ek alanın ise sadece etiket ismini yazdığınız anda istediğiniz ek bilgi için
      bu alan da doldurulabilir olacaktır.<br /><br />
      <strong>Link içeren örnek onay metni:</strong><br />
      <code>&lt;<strong>a href="</strong>https://www.tokenflex.com.tr/yasal-metin-bilgilendirme/tokenflex-kurumsal-musteri-temsilcisi-calisani-aydinlatma-metni<strong>" target="_blank"&gt;</strong>TokenFlex Kurumsal Müşteri Temsilcisi/Çalışanı Aydınlatma Metni<strong>&lt;/a&gt;</strong>’ni okudum, anladım.</code>
    </Alert>
    <AdminField
      label="E-posta"
      type="switch"
      value={campaign.formState.formEmail}
      onChange={(value) =>
        handleFormStateChange("formEmail", value)
      }
    />
    <AdminField
      label="Telefon"
      type="switch"
      value={campaign.formState.formPhone}
      onChange={(value) =>
        handleFormStateChange("formPhone", value)
      }
    />
    <AdminField
      label="Firma"
      type="switch"
      value={campaign.formState.formCompany}
      onChange={(value) =>
        handleFormStateChange("formCompany", value)
      }
    />
    <AdminField
      label="Cinsiyet"
      type="switch"
      value={campaign.formState.formGender}
      onChange={(value) =>
        handleFormStateChange("formGender", value)
      }
    />
    <AdminField
      label="Yasal Sözleşme Onay Kutucuğu Yazısı"
      value={campaign.formState.formContract}
      helperText="Eğer yasal kontrat onayı kullanacaksanız doldurunuz. Kontrat sayfasının linkini yukarıdaki örnekteki gibi uygulamaya dikkat ediniz."
      onChange={(value) => handleFormStateChange("formContract", value)}
      multiline
      rows={2}
    />
    <AdminField
      label="Opsiyonel Onay İzin Kutucuğu Yazısı"
      value={campaign.formState.formAddPermission}
      helperText="Eğer yasal kontrata ek olarak ikinci bir onay izin kutucuğu kullanacaksanız doldurunuz."
      onChange={(value) => handleFormStateChange("formAddPermission", value)}
      multiline
      rows={2}
    />
    <AdminField
      label="Opsiyonel Onay İzin Kutucuğu Başlığı"
      value={campaign.formState.formAddPermissionTitle}
      helperText="Excel çıktısında yer alacak Opsiyonel Onay İzin Kutucuğu Başlığını yazınız. Boş Bırakmanız halinde Onay1 yazılacaktır."
      onChange={(value) => handleFormStateChange("formAddPermissionTitle", value)}
    />
    <AdminField
      label="İkinci Opsiyonel Onay İzin Kutucuğu Yazısı"
      value={campaign.formState.formAddPermission2}
      helperText="Eğer ikinci bir opsiyonel onay izin kutucuğu kullanacaksanız doldurunuz."
      onChange={(value) => handleFormStateChange("formAddPermission2", value)}
      multiline
      rows={2}
    />
    <AdminField
      label="İkinci Opsiyonel Onay İzin Kutucuğu Başlığı"
      value={campaign.formState.formAddPermission2Title}
      helperText="Excel çıktısında yer alacak ikinci opsiyonel onay izin kutucuğu başlığını yazınız. Boş Bırakmanız halinde Onay2 yazılacaktır."
      onChange={(value) => handleFormStateChange("formAddPermission2Title", value)}
    />
    <AdminField
      label="Ek Alan Etiket İsmi"
      value={campaign.formState.bonusField}
      onChange={(value) => handleFormStateChange("bonusField", value)}
      helperText="Formda yer alacak ekstra özel bir ek alan kullanacaksanız bu alanın sadece etiketinde yer alacak başlığı yazınız."
    />
  </Grid>
</div>
}

export default FormCustomization